export class PriceRuleTreeModel {
    public priceRuleId: string;
    public priceRuleName: string;
    public statusCode: string;
    public children: PriceRuleTreeModel[];
}